import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9 7C7.89543 7 7 7.89543 7 9V23C7 24.1046 7.89543 25 9 25H23C24.1046 25 25 24.1046 25 23V9C25 7.89543 24.1046 7 23 7H9ZM14.3052 19.105L11.6702 16.42C11.6008 16.3528 11.5455 16.2723 11.5077 16.1834C11.4698 16.0944 11.4502 15.9988 11.45 15.9021C11.4498 15.8055 11.4689 15.7098 11.5064 15.6206C11.5438 15.5315 11.5987 15.4508 11.6678 15.3832C11.737 15.3157 11.8189 15.2627 11.9089 15.2274C11.9989 15.1921 12.0951 15.1752 12.1917 15.1777C12.2883 15.1802 12.3835 15.202 12.4715 15.2419C12.5595 15.2818 12.6387 15.339 12.7042 15.41L14.8222 17.577L19.4552 13.192C19.608 13.065 19.8016 12.9975 20.0002 13.0019C20.1989 13.0063 20.3892 13.0824 20.5362 13.216C20.6656 13.3602 20.733 13.5496 20.7238 13.7431C20.7147 13.9366 20.6297 14.1187 20.4872 14.25L15.3392 19.127C15.1963 19.2532 15.0129 19.3241 14.8222 19.327C14.7251 19.3296 14.6286 19.3112 14.5394 19.2728C14.4501 19.2345 14.3702 19.1772 14.3052 19.105Z",
      fill: "#28A3AF"
    }, null, -1)
  ]))]))
}
export default { render: render }